<!--
 * @name: 全局loading组件
 * @description: 全局loading组件
 * @author: huizi(huizi.li@shengyc.com)
 * @Date: 2020-02-28 22:42:28
 * @LastEditTime: 2020-02-29 01:33:08
 -->
<template>
  <div id="box">
    <div class="loadingStyle">
      <div class="loadingInnerStyle">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </div>
  </div>
</template>

<script>
import SycConfirm from '@/components/common/Confirem/';
import { pathOr, isWeiXin } from '@/config/Utils';
import { Dialog } from 'vant';
export default {
  name: 'EquipmentBasicInfo',
  components: { SycConfirm },
  data() {
    return {
      clientHeight: document.body.clientHeight
    };
  },
  props: {
    titleHeight: {
      type: Number
    }
  },
  created() {
    //   this.documentHeight + 'px';
  },
  mounted() {
    document.getElementById('box').style.height = this.clientHeight + 'px';
  },
  methods: {}
};
</script>

<style lang="scss">
@import '../../assets/style/mixin';
#box {
  // height: vw(552);
  @include fja(center, center);
  margin-top: vw(-80);
  .loadingStyle {
    @include fja(center, center);
    // background-color: pink;
    // flex: 1;
    width: 100%;
    // height: 100%;
    // display: flex;
    .loadingInnerStyle {
      padding: 20px;
      background-color: #666666;
      border-radius: 8px;
    }
  }
}
</style>
